import { useAppSelector } from "../store";
import { SmallVideoStream } from "../components/video-stream";
import { useLocation } from "react-router-dom";

export function SharedLayoutVideo() {
  const { x, y, width, height } = useAppSelector(
    (state) => state.modals.videoPosition
  );
  const messageContent = useAppSelector((state) => state.modals.messageContent);
  const { pathname } = useLocation();

  return (
    <div
      style={{
        opacity: x === 0 && y === 0 ? "0" : "1",
        pointerEvents: x === 0 && y === 0 ? "none" : "auto",
        position: "absolute",
        top: y,
        left: x,
        width,
        height,
        zIndex: 1000,
      }}
    >
      {!pathname.includes("mobile-app") && (
        <SmallVideoStream
          id="video-stream"
          videoClassName="rounded-lg !w-auto h-full object-cover"
          className={`z-[10000000] h-full`}
          messageContent={messageContent}
        />
      )}
    </div>
  );
}
